/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Principal } from './Principal';
import {
    PrincipalFromJSON,
    PrincipalFromJSONTyped,
    PrincipalToJSON,
} from './Principal';

/**
 * User group object with id and name.
 * @export
 * @interface UserGroup
 */
export interface UserGroup {
    /**
     * Unique user identifier
     * @type {string}
     * @memberof UserGroup
     */
    uid?: string;
    /**
     * Name of the user
     * @type {string}
     * @memberof UserGroup
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UserGroup
     */
    orgUnitId?: string;
    /**
     * List of members
     * @type {Array<Principal>}
     * @memberof UserGroup
     */
    members?: Array<Principal>;
    /**
     * List of subgroups
     * @type {Array<UserGroup>}
     * @memberof UserGroup
     */
    subGroups?: Array<UserGroup>;
    /**
     * Number of members
     * @type {number}
     * @memberof UserGroup
     */
    membersCount?: number;
}

/**
 * Check if a given object implements the UserGroup interface.
 */
export function instanceOfUserGroup(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UserGroupFromJSON(json: any): UserGroup {
    return UserGroupFromJSONTyped(json, false);
}

export function UserGroupFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserGroup {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'uid': !exists(json, 'uid') ? undefined : json['uid'],
        'name': !exists(json, 'name') ? undefined : json['name'],
        'orgUnitId': !exists(json, 'orgUnitId') ? undefined : json['orgUnitId'],
        'members': !exists(json, 'members') ? undefined : ((json['members'] as Array<any>).map(PrincipalFromJSON)),
        'subGroups': !exists(json, 'subGroups') ? undefined : ((json['subGroups'] as Array<any>).map(UserGroupFromJSON)),
        'membersCount': !exists(json, 'membersCount') ? undefined : json['membersCount'],
    };
}

export function UserGroupToJSON(value?: UserGroup | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'uid': value.uid,
        'name': value.name,
        'orgUnitId': value.orgUnitId,
        'members': value.members === undefined ? undefined : ((value.members as Array<any>).map(PrincipalToJSON)),
        'subGroups': value.subGroups === undefined ? undefined : ((value.subGroups as Array<any>).map(UserGroupToJSON)),
        'membersCount': value.membersCount,
    };
}

